import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "../../button/Button";
import Col from "../../grid/Col";
import Row from "../../grid/Row";
import { Popup, PopupButtons, PopupContent, PopupTitle } from "../../notify/Popup";
import { Text } from "../../typography/Text";
import config from "../../../config";

const msgKey = "newVersionReloadCheck";

export const NewVersionReloadCheck = () => {
    const [showReloadPrompt, setShowReloadPrompt] = useState(false);

    useEffect(() => {
        let isMounted = true;
        let lastKnownVersion = config.APP_VERSION || null;

        const checkInfo = async () => {
            try {
                const response = await fetch("/info.json", {
                    cache: "no-store",
                    headers: {
                        "Cache-Control": "no-cache"
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch /info.json (${response.status})`);
                }

                const info = await response.json();
                const currentVersion = info?.version || null;

                if (!currentVersion) {
                    return;
                }

                if (lastKnownVersion && currentVersion !== lastKnownVersion) {
                    console.log(
                        "[VP] New version detected (%s -> %s). Prompting user to reload...",
                        lastKnownVersion,
                        currentVersion
                    );
                    if (isMounted) {
                        setShowReloadPrompt(true);
                    }
                }

                lastKnownVersion = currentVersion;
            } catch (error) {
                console.warn("[VP] Failed to check /info.json", error);
            }
        };

        checkInfo();
        const intervalId = window.setInterval(checkInfo, 30000);

        return () => {
            isMounted = false;
            window.clearInterval(intervalId);
        };
    }, []);

    return showReloadPrompt ? (
        <Popup>
            <PopupTitle icon="exclamation-circle">
                <FormattedMessage id={`${msgKey}.title`} />
            </PopupTitle>
            <PopupContent>
                <Row>
                    <Col span={24}>
                        <Text size="medium" weight="semiBold">
                            <FormattedMessage id={`${msgKey}.newVersionMessage`} />
                        </Text>
                    </Col>
                    <Col span={24}>
                        <Text color="base80">
                            <FormattedMessage id={`${msgKey}.unsavedWorkMessage`} />
                        </Text>
                    </Col>
                </Row>
            </PopupContent>
            <PopupButtons>
                <Button iconColor="primary" icon="refresh" onClick={() => window.location.reload()}>
                    <FormattedMessage id={`${msgKey}.reload`} />
                </Button>
                <Button onClick={() => setShowReloadPrompt(false)} color="silent">
                    <FormattedMessage id={`${msgKey}.close`} />
                </Button>
            </PopupButtons>
        </Popup>
    ) : null;
};
